import { NgModule } from '@angular/core';
import { LibIdentityIconComponent } from './lib-identity-icon.component';

@NgModule({
  declarations: [LibIdentityIconComponent],
  imports: [],
  exports: [LibIdentityIconComponent],
})
export class LibIdentityIconModule {}
